import React from "react"
import { useAtom as GetAtom } from "jotai"
import { loadingSaleAtom } from "../../store/loading"
import { Loader2 } from "lucide-react"
import { cn } from "@malond/ui/utils"

function LoadingSale() {
  const [isLoading] = GetAtom(loadingSaleAtom)

  if (!isLoading) {
    return null
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-xs">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-24 lg:px-8">
        <div className="text-center">
          <Loader2 className="mx-auto size-20 animate-spin text-primary" />
          <p className="mt-4 text-2xl font-bold tracking-tight text-foreground sm:text-3xl lg:text-4xl">
            Идёт продажа...
          </p>
          <p className="mx-auto mt-4 max-w-xl text-lg text-muted-foreground">
            Пожалуйста, не закрывайте окно
          </p>
        </div>
      </div>
    </div>
  )
}

export default LoadingSale
